__turbopack_context__.v({
  "chip": "styles-module__yVwqDG__chip",
  "divider": "styles-module__yVwqDG__divider",
  "dividerLabel": "styles-module__yVwqDG__dividerLabel",
  "dividerLine": "styles-module__yVwqDG__dividerLine",
  "dividerTrail": "styles-module__yVwqDG__dividerTrail",
  "holder": "styles-module__yVwqDG__holder",
  "wrapper": "styles-module__yVwqDG__wrapper",
});
